/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAddressSchemaORM
 */
export interface ExecRiskAddressSchemaORM {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    formatted?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    locality: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    postal_code: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskAddressSchemaORM
     */
    region: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAddressSchemaORM
     */
    id: number;
}

/**
 * Check if a given object implements the ExecRiskAddressSchemaORM interface.
 */
export function instanceOfExecRiskAddressSchemaORM(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locality" in value;
    isInstance = isInstance && "postal_code" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ExecRiskAddressSchemaORMFromJSON(json: any): ExecRiskAddressSchemaORM {
    return ExecRiskAddressSchemaORMFromJSONTyped(json, false);
}

export function ExecRiskAddressSchemaORMFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAddressSchemaORM {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'country': !exists(json, 'country') ? undefined : json['country'],
        'formatted': !exists(json, 'formatted') ? undefined : json['formatted'],
        'line1': !exists(json, 'line1') ? undefined : json['line1'],
        'line2': !exists(json, 'line2') ? undefined : json['line2'],
        'locality': json['locality'],
        'postal_code': json['postal_code'],
        'region': json['region'],
        'id': json['id'],
    };
}

export function ExecRiskAddressSchemaORMToJSON(value?: ExecRiskAddressSchemaORM | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country': value.country,
        'formatted': value.formatted,
        'line1': value.line1,
        'line2': value.line2,
        'locality': value.locality,
        'postal_code': value.postal_code,
        'region': value.region,
        'id': value.id,
    };
}

